
import { OperationCategoryEnum, PoStatusEnum } from '@shahi-analytics/shared-models';
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('m_style_operation')
export class StyleOperationEntity extends CommonFieldsModel{
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'style'
    })
    style: string;

    @Column('varchar', {
        nullable: false,
        length: 6,
        name: 'op_code'
    })
    opCode: string;

    @Column('varchar', {
        nullable: false,
        length: 1,
        name: 'op_category'
    })
    opCategory: OperationCategoryEnum; 

    @Column('smallint', {
        nullable: false,
        name: 'op_sequence'
    })
    opSequence: number;
   
}

